import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  getAuth,
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  createUserWithEmailAndPassword,
} from "firebase/auth";

export async function signInEmail(email, password) {
  const auth = getAuth();

  return await createUserWithEmailAndPassword(auth, email, password);
}

export async function signInGoogle() {
  const provider = new GoogleAuthProvider();
  const auth = getAuth();

  provider.setCustomParameters({
    prompt: "select_account",
  });

  return await signInWithPopup(auth, provider);
}

export async function logOut() {
  const auth = getAuth();

  return await signOut(auth);
}

export async function persistAuth() {
  const auth = getAuth();

  return await setPersistence(auth, indexedDBLocalPersistence);
}

export async function logInEmail({ email, password }) {
  const auth = getAuth();
  return await signInWithEmailAndPassword(auth, email, password);
}

export function getUid() {
  const auth = getAuth();

  if (!auth?.currentUser || !auth?.currentUser?.uid) {
    return null;
  }
  return { user: auth.currentUser, auth, uid: auth.currentUser.uid };
}

export function getUserAuthInfo() {
  const auth = getAuth();

  if (!auth?.currentUser || !auth?.currentUser?.uid) {
    return null;
  }

  return auth?.currentUser;
}
